import { React, useRef, useState } from 'react';
import { items } from './constants';
import { Link } from 'react-router-dom';
import '../dashboard.scss';
import { useNavigateToClassicCastleMutation,
  useInitiateSiteSwitchLogMutation
} from '../../../features/authentication/authApiSlice';
import Modal from '../../../components/Modal/index';
import { Button } from 'react-bootstrap';
import CustomToast from '../../../components/Toast';

const DashboardItems = () => {
  const [navToClassic] = useNavigateToClassicCastleMutation();
  const [showGoToClassicModal, setShowGoToClassicModal] = useState(false);
  const [showRedirectModal, setRedirectModal] = useState(false);
  const reWriteUrl = useRef('');
  const [initialiseSiteSwitchLog] = useInitiateSiteSwitchLogMutation();

  async function handleNavToClassic(navLink) {
    try {
      var response = await navToClassic({
        reWriteUrl: navLink.replace('/dashboard', ''),
        selectedAssignmentId: null,
        selectedCenter: 'TeacherHome'
      });
      if (response.error) {
        CustomToast(response.error.data.error, 'error'); 
      } else {
        reWriteUrl.current = response.data.returnUrl;
        setShowGoToClassicModal(true);
      }
    } catch (ex) {
      console.log(ex);
    }
  }

  const handleSiteSwitchLog = async() => {
    try{
      var response = await initialiseSiteSwitchLog();
      window.location.href = reWriteUrl.current + '&logId='+response.data;
    }catch(ex){
      console.log(ex);
    }
  };

  return (
    <>
      <div className="dashboard_items_container mb-3">
        {items.map((value, index) => {
          const itemContent = (
            <>
              <div
                className="dashboard_item_icon mb-3 mx-auto d-flex justify-content-center align-items-center text-white"
                style={{ background: value.background }}>
                {value.icon}
              </div>
              <p className="mb-0" style={{ background: value.background }}>
                {value.name}
              </p>
            </>
          );

          if (!value.path.startsWith('/')) {
            return (
              <a
                key={index}
                style={{ '--main-color': value.iconColor, cursor: 'pointer' }}
                className="dashboard_item bg-white text-center p-4 rem_link_decor"
                //href={value.path}
                //target="_blank"
                onClick={() => handleNavToClassic(value.path)}
                rel="noreferrer">
                {value.comingSoon === true ? (
                  <div style={{ width: '100%', left: 0 }} className="comingSoonOverlay">
                    Coming Soon!
                  </div>
                ) : null}
                {itemContent}
              </a>
            );
          } else if (value.name === 'Create Assignment') {
            return (
              <Link
                key={index}
                style={{ '--main-color': value.iconColor }}
                className="dashboard_item bg-white text-center p-4 rem_link_decor"
                to={{ pathname: value.path }}
                state={{ keyProp: 'create' }}>
                {value.comingSoon === true ? (
                  <div style={{ width: '100%', left: 0 }} className="comingSoonOverlay">
                    Coming Soon!
                  </div>
                ) : null}
                {itemContent}
              </Link>
            );
          } else {
            return (
              <Link
                key={index}
                style={{ '--main-color': value.iconColor }}
                className="dashboard_item bg-white text-center p-4 rem_link_decor"
                to={value.path}>
                {value.comingSoon === true ? (
                  <div style={{ width: '100%', left: 0 }} className="comingSoonOverlay">
                    Coming Soon!
                  </div>
                ) : null}
                {itemContent}
              </Link>
            );
          }
        })}
      </div>
      <Modal
        contentWidth="25%"
        isOpen={showGoToClassicModal}
        titleName={'Go to Classic Castle'}
        onClose={() => setShowGoToClassicModal(false)}>
        <div className="d-flex flex-column align-items-center">
          <div className="fw-bold">We see you appreciate the classics!</div>

          <div className="my-3">
            These pages are a work in progress. For now they will redirect you to Classic Castle
          </div>

          <div className="d-flex flex-row justify-content-end w-100 mt-4">
            <Button
              variant="castleGray"
              onClick={() => setShowGoToClassicModal(false)}
              className="me-2 btn-width">
              Cancel
            </Button>
            <Button
              variant="castleOrange"
              onClick={async() => {
                await handleSiteSwitchLog();
                setShowGoToClassicModal(false);
                setRedirectModal(true);
              }}
              className="btn-width">
              Switch Back
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        contentWidth="40%"
        isOpen={showRedirectModal}
        onClose={() => {}}
        titleName={'Returning to Classic Castle'}
        hideClosingX={true}
        disableBackdropClose={true}>
        <div className="d-flex flex-column align-items-center">
          <div>You will now be redirected to Classic Castle...</div>
        </div>
      </Modal>
    </>
  );
};

export default DashboardItems;
